<template>
  <v-divider class="mb-1"></v-divider>
</template>

<script>
export default {
  name: 'DividerMenuItem'
};
</script>
